module.exports = __webpack_public_path__ + "static/p-b-link-long-c06a3d307a82e340be1e4cc7c02bf110.svg";